// extracted by mini-css-extract-plugin
export default {"minimap-section-container":"SectionWithText_minimap-section-container__oyqiZ","section-text":"SectionWithText_section-text__HSkfA"};